export default __webpack_public_path__ + "static/media/ic-inside-the-box-items.650530ac.png";